<template>
    <div class="foodDetails">
        <swiperList :swiperStyle="{padding: '0 0 .8rem'}">
            <div :class="['topImg',{topImg1: secondLevelIndex != 1}]">
                <img :src="currentData.thumb" v-if="!imgUrl">
                <img :src="imgUrl" alt="" v-if="imgUrl">
            </div>
            <div class="textBox"></div>
            <div class="textBox1"></div>
            <h2 v-html="currentData.title.replace(/<br \/>/g,'')" class="foodTitle"></h2>
            <!-- <p>{{ currentData.description }}</p> -->
            <p>
                <span v-for="(item,index) in currentData.keywords.split('|')" :key="index"  v-show="currentData.keywords">{{ item }}</span>
            </p>
            <textContent></textContent>
            <div class="goumaid" v-if="currentData.notice">
                <span class="topTuijian">推荐购买点</span>
                <div
                class="goumaidSlide"
                v-for="(item,index) in goumaidList"
                :key="index"
                >
                    <div class="goumaidLeft">
                        <h2 class="goumaidTitle">{{ item.title }}</h2>
                        <p>{{ item.contacts }}</p>
                    </div>
                    <a :class="['phone',{phone1: !item.phone}]" :href="'tel:' + item.phone">
                        <img src="@/assets\img\details/phone.png" alt="">
                    </a>
                </div>
            </div>
        </swiperList>
        <backButton :routerName="routerName" zIindex="10"></backButton>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
import textContent from "@/components/textContent";
export default {
    data() { 
        return {
            currentData: {},
            imgUrl: "",
            goumaidList: []
        }
    },
    created(){
        this.currentData = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex];
        console.log(this.currentData);
        let goumaidArr = this.currentData.notice.split("<br />");
        goumaidArr.forEach(item => {
            let obj = {
                title: item.split("|")[0],
                contacts: item.split("|")[1],
                phone: item.split("|")[2]
            }
            this.goumaidList.push(obj);
        });
        console.log(goumaidArr);
        if(this.firstLevelIndex == 5){
            let arr = this.currentData.images.replace(/\n/g,"").split("<br />")[0].split("|");
            this.imgUrl = this.getImgSrc(arr[2],false);
            console.log(this.imgUrl);
            setTimeout(() => {
                this.setIndex({firstLevelIndex: 3,secondLevelIndex: 3});
            },100);
        }
        
    },
    methods: {
        ...publicData.mapMutations(["setIndex"])
    },
    computed: {
        routerName(){
            if(this.firstLevelIndex == 3){
                return "shopping";
            }else{
                if(this.secondLevelIndex == 1){
                    return "food";
                }
                return "renjie";
            }
        },
        bgImg(){
            if(this.currentData.images){
                let arr = this.currentData.images.replace(/\n/g,"").split("<br />");
                for(let i = 0; i < arr.length; i++){
                    if(arr[i].indexOf("背景") != -1 || arr[i].indexOf("GPS") != -1){
                        return this.getImgSrc(arr[i],false);
                    }
                }
            }
        },
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex","levelThreeIndex"])
    },
    components: {
        textContent,
        // backButton
    }
}
</script>

<style lang="scss" scoped>
.foodDetails{
    .topImg{
        width: 4.42rem;
        height: 2.82rem;
        margin: .18rem auto 0;
        &.topImg1{
            width: 2.82rem;
        }
        img{
            height: 100%;
        }
    }
    .textBox{
        width: 100%;
        height: auto;
        border-radius: .4rem .4rem 0 0;
        box-shadow:0px -.03rem .35rem 0px rgba(50,50,50,0.22);
        padding: .6rem 0 .5rem;
        margin-top: -.9rem;
        background: #fff;
    }
    .textBox1{
        width: 100%;
        height: .6rem;
        background: #fff;
        margin-top: -.1rem;
    }
    .foodTitle{
        color: #333;
        font-size: .46rem;
        font-weight: bold;
        text-align: center;
        // margin-top: .38rem;
    }
    p{
        font-size: .24rem;
        color: #999;
        margin-top: .17rem;
        margin-bottom: .55rem;
        text-align: center;
        padding: 0 .4rem;
        display: flex;
        justify-content: center;
        span{
            color: #4FC0AC;
            background: rgba(108,214,196,.2);
            padding: .1rem .2rem;
            border-radius: .26rem;
        }
    }
    .goumaid{
        width: 6.7rem;
        height: auto;
        overflow: hidden;
        border-radius: .06rem;
        background: #F2F2F2;
        margin: .8rem auto 0;
        position: relative;
        padding: .66rem .58rem .52rem .32rem;
        .goumaidSlide{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: .4rem;
            &:first-of-type{
                margin-top: 0;
            }
        }
        .goumaidLeft{
            .goumaidTitle{
                font-size: .34rem;
                color: #333;
                text-align: left;
            }
            p{
                color: #999;
                font-size: .24rem;
                padding: 0;
                margin: 0;
                margin-top: .22rem;
                text-align: left;
                display: block;
            }
        }
        .phone{
            width: .9rem;
            height: .9rem;
            border-radius: 50%;
            border: 1px solid #5BC2AB;
            display: flex;
            align-items: center;
            justify-content: center;
            &.phone1{
                opacity: .5;
            }
            img{
                width: .46rem;
                height: .46rem;
            }
        }
        .topTuijian{
            width: 1.34rem;
            height: .36rem;
            background: linear-gradient(0deg, #54BDA4 0%, #77DECC 100%);
            border-radius: .06rem 0px .1rem 0px;
            position: absolute;
            left: 0;
            top: 0;
            font-size: .22rem;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>